import Login from "./pages/Login";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import { IRoute } from "./common/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBurger,
  faClock,
  faCodeBranch,
  faGaugeHigh,
  faGear,
  faShop,
  faUsers,
  faUtensils,
  faCogs,
  faReceipt,
  faList,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import ProductList from "./pages/ProductList";
import { RobinLayout } from "./components/core/RobinLayout";
import ProductMutate from "./pages/ProductMutate";
import Settings from "./pages/Settings";
import StoreList from "./pages/StoreList";
import CategoryList from "./pages/CategoryList";
import StoreMutate from "./pages/StoreMutate";
import Profile from "./pages/Profile";
import ProfileUpdate from "./pages/ProfileUpdate";
import SettingsUsers from "./pages/SettingsUsers";
import ConfirmInvite from "./pages/ConfirmInvite";
import WorkingHours from "./pages/WorkingHours";
import ProductOptionCategoryList from "./pages/ProductOptionCategoryList";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import TransactionsList from "./pages/TransactionsList";
import Balance from "./pages/Balance";
import NotAuthorizedPage from "./pages/403";
import NotFoundPage from "./pages/404";
import { ProtectedRoute } from "./components/ProtectedRoute";
import SettingsPartnerInfo from "./pages/SettingsPartnerInfo";

export const AppRoutes: IRoute[] = [
  {
    path: "/dashboard",
    index: true,
    showInMenu: true,
    icon: <FontAwesomeIcon icon={faGaugeHigh} />,
    label: "label.menu.dashboard",
    component: <Dashboard />,
  },
  {
    path: "/menu",
    showInMenu: true,
    asParent: true,
    icon: <FontAwesomeIcon icon={faUtensils} />,
    label: "label.menu.productsMenu",
    component: <ProductList />,
  },
  {
    path: "/menu/products",
    showInMenu: true,
    asChild: true,
    icon: <FontAwesomeIcon icon={faBurger} />,
    label: "label.menu.products",
    component: <ProductList />,
  },
  {
    path: "/menu/products/mutate",
    component: <ProductMutate />,
  },
  {
    path: "/menu/products/mutate/:id",
    component: <ProductMutate />,
  },
  {
    path: "/menu/products/categories",
    showInMenu: true,
    asChild: true,
    icon: <FontAwesomeIcon icon={faCodeBranch} />,
    label: "label.menu.product_categories",
    component: <CategoryList />,
  },
  {
    path: "/menu/product-option/categories",
    showInMenu: true,
    asChild: true,
    icon: <FontAwesomeIcon icon={faCogs} />,
    label: "label.menu.productOptionCategories",
    component: <ProductOptionCategoryList />,
  },
  {
    path: "/transactions",
    showInMenu: true,
    asParent: true,
    icon: <FontAwesomeIcon icon={faReceipt} />,
    label: "label.menu.transactions",
    component: <TransactionsList />,
  },
  {
    path: "/transactions/list",
    showInMenu: true,
    asChild: true,
    icon: <FontAwesomeIcon icon={faList} />,
    label: "label.menu.transactionsList",
    component: <TransactionsList />,
  },
  {
    path: "/transactions/balance",
    showInMenu: true,
    asChild: true,
    icon: <FontAwesomeIcon icon={faWallet} />,
    label: "label.menu.balance",
    component: <Balance />,
  },
  {
    path: "/settings",
    showInMenu: true,
    asParent: true,
    icon: <FontAwesomeIcon icon={faGear} />,
    label: "label.menu.settings",
    component: <Settings />,
  },
  {
    path: "/settings/partner-info",
    showInMenu: true,
    asChild: true,
    icon: <FontAwesomeIcon icon={faShop} />,
    label: "label.menu.partnerInfo",
    component: <SettingsPartnerInfo />,
  },
  {
    path: "/settings/stores",
    showInMenu: true,
    asChild: true,
    icon: <FontAwesomeIcon icon={faShop} />,
    label: "label.menu.stores",
    component: <StoreList />,
  },
  {
    path: "/settings/users",
    showInMenu: true,
    asChild: true,
    icon: <FontAwesomeIcon icon={faUsers} />,
    label: "label.menu.users",
    component: <SettingsUsers />,
  },
  {
    path: "/settings/working-hours",
    showInMenu: true,
    asChild: true,
    icon: <FontAwesomeIcon icon={faClock} />,
    label: "label.menu.workingHours",
    component: <WorkingHours />,
  },
  {
    path: "/settings/stores/mutate",
    component: <StoreMutate />,
  },
  {
    path: "/settings/stores/mutate/:id",
    component: <StoreMutate />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/profile/update",
    component: <ProfileUpdate />,
  },
  {
    path: "/login",
    ignoreLayout: true,
    component: <Login />,
  },
  {
    path: "/forgot-password",
    ignoreLayout: true,
    component: <ForgotPassword />,
  },
  {
    path: "/reset-password/:token",
    ignoreLayout: true,
    component: <ResetPassword />,
  },
  {
    path: "/invite/:token",
    ignoreLayout: true,
    component: <ConfirmInvite />,
  },
  {
    path: "/403",
    ignoreLayout: true,
    component: <NotAuthorizedPage />,
  },
  {
    path: "*",
    ignoreLayout: true,
    component: <NotFoundPage />,
  },
];

export function AppRoute() {
  return (
    <Routes>
      {AppRoutes.map((route) => {
        const child = <RobinLayout children={route.component} />;
        const protectedChild = (
          <ProtectedRoute path={route.path}>{child}</ProtectedRoute>
        );

        if (route.ignoreLayout) {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={route.component}
            />
          );
        }
        else if (route.index)
          return [
            <Route key="/" path="/" index element={protectedChild} />,
            <Route key={route.path} path={route.path} element={protectedChild} />,
          ];
        else
          return <Route key={route.path} path={route.path} element={protectedChild} />;
      })}
    </Routes>
  );
}
